import useSWR from 'swr'
import { Client, Interceptors } from '@avcan/utils/fetch'
import * as URLUtils from '@avcan/utils/url'

const HazardClient = (base, key) => {
    const path = URLUtils.buildPath(base, 'forecasts', 'en', 'highestHazard')
    const client = new Client(path, new Interceptors.APIKey(key))

    const getHazard = ({ fromDate, toDate, lat, lng }) => {
        const params = {
            lat,
            long: lng,
            fromDate,
            toDate,
        }
        const url = URLUtils.appendParams('', params)

        return client.get(url)
    }

    return {
        path,
        getHazard,
    }
}

const base = process.env.NEXT_PUBLIC_AVCAN_API_URL
const apiKey = process.env.NEXT_PUBLIC_AVCAN_API_KEY
const { getHazard, path } = HazardClient(base, apiKey)

export const useHighestHazard = ({ fromDate, toDate, lat, lng }) => {
    // Conditionally fetch data only if lat and lng are defined
    return useSWR(
        lat && lng && fromDate && toDate
            ? path + '-' + fromDate + '-' + toDate + '-' + lat + '-' + lng
            : null,
        () => getHazard({ fromDate, toDate, lat, lng })
    )
}
